// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

// Off-the-shelf controllers (stimulus-components) — no local subclass needed.
import CheckboxSelectAll from "@stimulus-components/checkbox-select-all"
import Clipboard from "@stimulus-components/clipboard"
import PasswordVisibility from "@stimulus-components/password-visibility"

// Host controllers (chrome-owned — the layout/dialog they drive lives in the host).
import ModalController from "./controllers/modal_controller"

// EventCore engine controllers (imported from engine source; esbuild resolves the
// relative path at build time).
import NfcReaderController from "../../engines/event_core/app/javascript/event_core/controllers/nfc_reader_controller"
import NfcGuardController from "../../engines/event_core/app/javascript/event_core/controllers/nfc_guard_controller"
import NfcCodeInputController from "../../engines/event_core/app/javascript/event_core/controllers/nfc_code_input_controller"
import NfcWriterController from "../../engines/event_core/app/javascript/event_core/controllers/nfc_writer_controller"
import SortableController from "../../engines/event_core/app/javascript/event_core/controllers/sortable_controller"
import KioskPosController from "../../engines/event_core/app/javascript/event_core/controllers/kiosk_pos_controller"
import KioskStockChannelController from "../../engines/event_core/app/javascript/event_core/controllers/kiosk_stock_channel_controller"
import CardLoaderController from "../../engines/event_core/app/javascript/event_core/controllers/card_loader_controller"
import AutoDismissController from "../../engines/event_core/app/javascript/event_core/controllers/auto_dismiss_controller"
import InfiniteScrollController from "../../engines/event_core/app/javascript/event_core/controllers/infinite_scroll_controller"
import SaleCancellationController from "../../engines/event_core/app/javascript/event_core/controllers/sale_cancellation_controller"
import SaleCancellationFormController from "../../engines/event_core/app/javascript/event_core/controllers/sale_cancellation_form_controller"
import OfflineGateController from "../../engines/event_core/app/javascript/event_core/controllers/offline_gate_controller"
import ConnectivityMonitorController from "../../engines/event_core/app/javascript/event_core/controllers/connectivity_monitor_controller"
import ServiceWorkerController from "../../engines/event_core/app/javascript/event_core/controllers/service_worker_controller"
import ChartController from "../../engines/event_core/app/javascript/event_core/controllers/chart_controller"
import NfcDashboardController from "../../engines/event_core/app/javascript/event_core/controllers/nfc_dashboard_controller"
import QrScannerController from "../../engines/event_core/app/javascript/event_core/controllers/qr_scanner_controller"
import CardStatementLoginController from "../../engines/event_core/app/javascript/event_core/controllers/card_statement_login_controller"
import SponsorsCarouselController from "../../engines/event_core/app/javascript/event_core/controllers/sponsors_carousel_controller"
import RepeaterController from "../../engines/event_core/app/javascript/event_core/controllers/repeater_controller"
import CountdownController from "../../engines/event_core/app/javascript/event_core/controllers/countdown_controller"
import DropzoneController from "../../engines/event_core/app/javascript/event_core/controllers/dropzone_controller"
import RolePermissionsController from "../../engines/event_core/app/javascript/event_core/controllers/role_permissions_controller"
import EventSwitcherController from "../../engines/event_core/app/javascript/event_core/controllers/event_switcher_controller"
import AutoSubmitController from "../../engines/event_core/app/javascript/event_core/controllers/auto_submit_controller"
import ImagePickerController from "../../engines/event_core/app/javascript/event_core/controllers/image_picker_controller"
import CategoryFilterController from "../../engines/event_core/app/javascript/event_core/controllers/category_filter_controller"
import TomSelectController from "../../engines/event_core/app/javascript/event_core/controllers/tom_select_controller"
import SvgToPngController from "../../engines/event_core/app/javascript/event_core/controllers/svg_to_png_controller"
import CategorySuggestController from "../../engines/event_core/app/javascript/event_core/controllers/category_suggest_controller"

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("checkbox-select-all", CheckboxSelectAll)
application.register("clipboard", Clipboard)
application.register("password-visibility", PasswordVisibility)
application.register("modal", ModalController)
application.register("nfc-reader", NfcReaderController)
application.register("nfc-guard", NfcGuardController)
application.register("nfc-code-input", NfcCodeInputController)
application.register("nfc-writer", NfcWriterController)
application.register("sortable", SortableController)
application.register("kiosk-pos", KioskPosController)
application.register("kiosk-stock-channel", KioskStockChannelController)
application.register("card-loader", CardLoaderController)
application.register("auto-dismiss", AutoDismissController)
application.register("infinite-scroll", InfiniteScrollController)
application.register("sale-cancellation", SaleCancellationController)
application.register("sale-cancellation-form", SaleCancellationFormController)
application.register("offline-gate", OfflineGateController)
application.register("connectivity-monitor", ConnectivityMonitorController)
application.register("service-worker", ServiceWorkerController)
application.register("chart", ChartController)
application.register("nfc-dashboard", NfcDashboardController)
application.register("qr-scanner", QrScannerController)
application.register("card-statement-login", CardStatementLoginController)
application.register("sponsors-carousel", SponsorsCarouselController)
application.register("repeater", RepeaterController)
application.register("countdown", CountdownController)
application.register("dropzone", DropzoneController)
application.register("role-permissions", RolePermissionsController)
application.register("auto-submit", AutoSubmitController)
application.register("event-switcher", EventSwitcherController)
application.register("image-picker", ImagePickerController)
application.register("category-filter", CategoryFilterController)
application.register("category-suggest", CategorySuggestController)
application.register("tom-select", TomSelectController)
application.register("svg-to-png", SvgToPngController)

import "trix"
import "@rails/actiontext"
